import styled from 'styled-components';

import { getSeverityColor } from 'utils/color/helpers';

interface StyledCircleProps {
  severity: number;
  maxValue: number;
}
export const StyledCircle = styled.span<StyledCircleProps>`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${({ theme, severity, maxValue = 5 }) =>
    getSeverityColor(theme, severity, maxValue)};
  display: inline-block;
`;

export const SeverityContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
`;
